const getClientCode = state => state.client?.code ?? '';

export default getClientCode;
